var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtectingPrivacyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.46 104.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-2,.cls-5{mix-blend-mode:multiply;}.cls-2{fill:url(#radial-gradient);}.cls-3{isolation:isolate;}.cls-4{mask:url(#mask-2);}.cls-5{fill:url(#radial-gradient-2);}.cls-6{fill:#0d4d8d;}.cls-7{fill:#f6f6f6;}.cls-8{fill:#3c3c3b;}.cls-9{fill:#30225f;}.cls-10{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: -8179.79,
    width: 89.28,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: -8179.79,
    width: 89.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 421.4,
    cy: -202.22,
    r: 37.83,
    gradientTransform: "translate(-194 -452.69) rotate(90) scale(1.18 1.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 0,
    y: 0,
    width: 89.28,
    height: 89.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    width: 89.28,
    height: 89.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.2,76.21a44.64,44.64,0,1,1,0-63.14A44.65,44.65,0,0,1,76.2,76.21Z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 421.4,
    cy: -202.22,
    r: 37.83,
    gradientTransform: "translate(-194 -452.69) rotate(90) scale(1.18 1.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1f1f1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#272725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#353533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#61615f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a4a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About_Us_Page",
    "data-name": "About Us Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Our_principles",
    "data-name": "Our principles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Protecting_Privacy_Image",
    "data-name": "Protecting Privacy Image"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.2,76.21a44.64,44.64,0,1,1,0-63.14A44.65,44.65,0,0,1,76.2,76.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.78,76.63A38.41,38.41,0,1,1,85,53.58,38.4,38.4,0,0,1,35.78,76.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.86,66A30.38,30.38,0,1,0,23,24.19,30.39,30.39,0,0,0,32.86,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.87,88.61a2.95,2.95,0,1,1-2.95-3A2.95,2.95,0,0,1,50.87,88.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.13,57.9a47.34,47.34,0,0,1-88.27,0H4.14a48,48,0,0,0,89.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.3,58.64a3.16,3.16,0,1,1-3.16-3.17A3.15,3.15,0,0,1,7.3,58.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.46,57.9A2.95,2.95,0,1,1,93.52,55,2.94,2.94,0,0,1,96.46,57.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 47.52,
    y: 87.9,
    width: 0.73,
    height: 7.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.34,100a2.39,2.39,0,0,1-4.77,0,2.39,2.39,0,1,1,4.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.92,104.9A4.93,4.93,0,1,1,52.85,100,4.93,4.93,0,0,1,47.92,104.9Zm0-9.51A4.59,4.59,0,1,0,52.51,100,4.58,4.58,0,0,0,47.92,95.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64.56,59.09a3.27,3.27,0,0,1-2.37-1L55,50.7a.58.58,0,0,1,0-.82.59.59,0,0,1,.82,0L63,57.28a2.15,2.15,0,0,0,1.55.66h0a2.11,2.11,0,0,0,1.54-.66,2.29,2.29,0,0,0,0-3.2l-7.3-7.49a.58.58,0,1,1,.83-.81l7.3,7.49a3.47,3.47,0,0,1,0,4.82,3.27,3.27,0,0,1-2.37,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.73,52.62A13.73,13.73,0,1,1,61.14,38.9,13.58,13.58,0,0,1,47.73,52.62Zm0-26.29A12.57,12.57,0,1,0,60,38.9,12.42,12.42,0,0,0,47.73,26.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.88,40.42a2.68,2.68,0,0,1-2.68-2.67.58.58,0,0,1,1.16,0,1.52,1.52,0,0,0,1.52,1.52.58.58,0,0,1,.58.58A.57.57,0,0,1,48.88,40.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.73,45.53a11.48,11.48,0,0,1-10.24-6.37.59.59,0,0,1,0-.52,11.42,11.42,0,0,1,20.48,0,.59.59,0,0,1,0,.52A11.48,11.48,0,0,1,47.73,45.53ZM38.66,38.9a10.25,10.25,0,0,0,18.14,0,10.25,10.25,0,0,0-18.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64.11,31.28a.57.57,0,0,1-.57-.57V23.09H55.92a.58.58,0,1,1,0-1.15h8.19a.58.58,0,0,1,.58.58v8.19A.58.58,0,0,1,64.11,31.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.35,31.28a.58.58,0,0,1-.58-.57V22.52a.58.58,0,0,1,.58-.58h8.19a.58.58,0,1,1,0,1.15H31.93v7.62A.58.58,0,0,1,31.35,31.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.54,55.86H31.35a.58.58,0,0,1-.58-.58V47.09a.58.58,0,0,1,1.16,0V54.7h7.61a.58.58,0,0,1,0,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.73,43.18A4.29,4.29,0,1,1,52,38.9,4.28,4.28,0,0,1,47.73,43.18Zm0-7.41a3.13,3.13,0,1,0,3.13,3.13A3.13,3.13,0,0,0,47.73,35.77Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectingPrivacyImage);
export default __webpack_public_path__ + "static/media/protecting-privacy-image.3a230fe23f51199a64fecc0be6db4f2d.svg";
export { ForwardRef as ReactComponent };